import { AvailabilityEnum } from '../modules/products/ProductTypes';

interface GetOrderProductCombinationKeyParams {
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string;
}

export const getOrderProductCombinationKey = ({
  productColorId,
  availability,
  deliveryWindowId,
}: GetOrderProductCombinationKeyParams) =>
  `${productColorId}|${availability}|${deliveryWindowId ?? 'null'}`;
